import { cn } from "@workspace/ui/lib/utils";

export interface PillFilterItem {
  key: string;
  label: string;
}

interface PillFilterProps {
  items: PillFilterItem[];
  activeKey: string;
  onSelect: (key: string) => void;
  size?: "sm" | "lg";
  itemClassName?: string;
  /** When set, each button gets an id of `${itemIdPrefix}-1`, `${itemIdPrefix}-2`, ... */
  itemIdPrefix?: string;
}

export function PillFilter({
  items,
  activeKey,
  onSelect,
  size = "sm",
  itemClassName,
  itemIdPrefix,
}: PillFilterProps) {
  return (
    <div className="inline-flex w-max shrink-0 gap-2 lg:gap-3 flex-nowrap pr-6 lg:pr-0">
      {items.map((item, index) => {
        const isActive = item.key === activeKey;
        const id = itemIdPrefix ? `${itemIdPrefix}-${index + 1}` : undefined;
        return (
          <button
            key={item.key}
            id={id}
            data-testid={id}
            type="button"
            onClick={() => onSelect(item.key)}
            className={cn(
              "rounded-full whitespace-nowrap transition-colors cursor-pointer",
              itemClassName,
              size === "lg"
                ? "px-[18px] py-2.5 title-18"
                : "px-3.5 py-2 title-14",
              isActive
                ? "border-2 border-primary text-primary"
                : "border border-[#cecbc9] text-secondary",
            )}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
